import { Component, OnInit, Input } from '@angular/core';
import {
  DetailReportParticipantCategory,
  ParticipantCategoryNames,
} from '../../../../../../models/reporting';
import { ReportingService } from '../../../../../../services/reporting.service';

@Component({
  selector: 'app-question-scale',
  templateUrl: './question-scale.component.html',
  styles: [],
})
export class QuestionScaleComponent implements OnInit {
  @Input() respondentGroup: Array<DetailReportParticipantCategory>;
  @Input() scaleMaxValue: number;

  countedRespondentGroup: Array<DetailReportParticipantCategory>;

  categoryType: any = ParticipantCategoryNames;
  constructor(private reportingService: ReportingService) {}

  ngOnInit() {
    this.countedRespondentGroup = this.respondentGroup
      .map((rg) =>
        Object.assign({}, rg, {
          isAnswersEnough:
            rg.answers.reduce((acc, cur) => acc + cur.respondentCount, 0) >= 3,
        })
      )
      .sort((a, b) => Number(b.isAnswersEnough) - Number(a.isAnswersEnough));
  }

  getCategoryTitle(question: DetailReportParticipantCategory) {
    return question.gradeName
      ? question.gradeName
      : this.reportingService.getParticipantCategoryTitle(
          +question.participantCategoryType
        );
  }

  canShowScale(question: DetailReportParticipantCategory): boolean {
    return (
      question.participantCategoryType === this.categoryType.Self ||
      question.isAnswersEnough ||
      question.isRespondentsVisible
    );
  }
}
